// ============================================================================
// Shared "which agent tools exist" catalog.
//
// Hoisted out of WelcomeModal.tsx (2026-10-08) so the onboarding wizard's
// step 6 ("Connect your agents") and the Agents page's "+ Add Agent" sidebar
// (TeamAgents.tsx) read the same list instead of each hardcoding its own --
// those two already drifted once (the onboarding wizard's tool list and
// AllowedAgentsConfig.tsx's separate admin allow-list catalog still don't
// match each other; that's a pre-existing gap this change doesn't fix, see
// the note on AllowedAgentsConfig.tsx).
//
// Only Claude Code has a real connect flow today -- see ConnectAgentModal's
// header comment for why Codex/Cursor/ChatGPT stay disabled. `kind` is the
// terminal-vs-desktop split used to group the catalog in AgentConnectGrid;
// it's a deliberate choice over grouping by provider (Anthropic/OpenAI/
// Cursor's Anysphere) because the connection *mechanism* (paste-a-command
// hook install vs. app/browser pairing) tracks `kind`, not the vendor --
// see the 2026-10-08 conversation this came out of.
// ============================================================================

export type AgentConnectionKind = 'terminal' | 'desktop'

export interface AgentToolDef {
  id: 'claude-code' | 'codex' | 'cursor' | 'chatgpt'
  name: string
  description: string
  badge: string
  kind: AgentConnectionKind
  available: boolean
}

export const AGENT_TOOLS: AgentToolDef[] = [
  {
    id: 'claude-code',
    name: 'Claude Code',
    description: 'Reports project chats and file edits via a terminal hook.',
    badge: 'CLI',
    kind: 'terminal',
    available: true,
  },
  {
    id: 'codex',
    name: 'Codex',
    description: 'Reports CI runs and release status.',
    badge: 'MCP',
    kind: 'terminal',
    available: false,
  },
  {
    id: 'cursor',
    name: 'Cursor',
    description: 'Reports edits and opened PRs.',
    badge: 'APP',
    kind: 'desktop',
    available: false,
  },
  // Added 2026-10-08 per explicit plan to show it as "coming soon" -- no
  // integration, no hook, no pairing flow exists for it yet, same as
  // Cursor above.
  {
    id: 'chatgpt',
    name: 'ChatGPT',
    description: 'No integration built yet — nothing to connect.',
    badge: 'APP',
    kind: 'desktop',
    available: false,
  },
]
